var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"z-index":"90","position":"fixed","left":"0px","top":"0px","overflow-y":"scroll"},attrs:{"width":"100vw","height":"100vh"}},[_c('PageTitle'),_c('PersonDetails',{attrs:{"donorId":_vm.$route.query.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }